// utils/passwordStrength.js
export const validatePasswordStrength = (password) => {
  const checks = {
    length: password.length >= 8,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
  };

  const strength = Object.values(checks).filter(Boolean).length;
  
  let strengthLevel = 'weak';
  let message = '';
  
  if (strength >= 5) {
    strengthLevel = 'strong';
    message = 'Strong password';
  } else if (strength >= 3) {
    strengthLevel = 'medium';
    message = 'Medium strength password';
  } else {
    strengthLevel = 'weak';
    message = 'Weak password';
  }

  return {
    isValid: strength >= 3, // At least medium strength
    strengthLevel,
    message,
    checks
  };
};

export const getPasswordRequirements = () => [
  'At least 8 characters',
  'One uppercase letter',
  'One lowercase letter', 
  'One number',
  'One special character (!@#$%^&* etc.)'
];